import { UseQueryResult, keepPreviousData } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'

import { Group, parseGroup } from '../../models/Group'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'

export default function useGroupSuggestions(init?: string | null) {
  const [query, setQuery] = useState(init)

  const [currentQuery, debounceState] = useDebounce(query, 300)

  const result: UseQueryResult<Group[]> = useApiQuery({
    queryKey: ['groupSuggestions', currentQuery],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      parseGroup
        .array(
          (
            await api.get(
              `group?page=1&page_size=10&search=${encodeURIComponent(currentQuery || '')}&only_manageable=true`
            )
          )?.data
        )
        .filter(({ error }) => !error),
  })

  const suggestions = useMemo(() => result.data || [], [result.data])

  return {
    query,
    setQuery,
    suggestions,
    isFetching: result.isFetching || debounceState.isPending(),
    result,
  }
}
